var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("TransparentHeader", {
        attrs: { color: "#FF273A", "title-color": "#FFFFFF", customOpacity: 1 },
      }),
      _vm.prizeTotalShow
        ? _c("div", { staticClass: "panel prize-total" }, [
            _vm.stat.cash_amount > 0
              ? _c(
                  "div",
                  {
                    staticClass: "prize-total-item van-hairline--bottom icon1",
                  },
                  [
                    _c("div", { staticClass: "item-left" }, [
                      _vm._v("现金红包 "),
                      _c("span", [
                        _vm._v(_vm._s(parseFloat(_vm.stat.cash_amount)) + "元"),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.stat.gy_red_amount > 0
              ? _c(
                  "div",
                  {
                    staticClass: "prize-total-item van-hairline--bottom icon2",
                  },
                  [
                    _c("div", { staticClass: "item-left" }, [
                      _vm._v("高佣红包 "),
                      _c("span", [
                        _vm._v(
                          _vm._s(parseFloat(_vm.stat.gy_red_amount)) + "元"
                        ),
                      ]),
                    ]),
                    parseFloat(_vm.stat.gy_red_amount)
                      ? _c(
                          "div",
                          {
                            staticClass: "use-btn",
                            on: { click: _vm.goRedPacketCenter },
                          },
                          [_vm._v("使用高佣红包")]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.stat.butler_day > 0
              ? _c(
                  "div",
                  {
                    staticClass: "prize-total-item van-hairline--bottom icon3",
                  },
                  [
                    _c("div", { staticClass: "item-left" }, [
                      _vm._v("大管家 "),
                      _c("span", [_vm._v(_vm._s(_vm.stat.butler_day) + "天")]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.stat.real_goods_list.length
              ? _c("div", { staticClass: "prize-total-item icon4" }, [
                  _c("div", { staticClass: "item-left" }, [
                    _vm._v("实物奖品 "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.stat.real_goods_num) + "个"),
                    ]),
                  ]),
                  _vm.stat.real_goods_num
                    ? _c(
                        "div",
                        {
                          staticClass: "address-btn",
                          on: {
                            click: function ($event) {
                              _vm.addressPop = true
                            },
                          },
                        },
                        [_vm._v("收货地址")]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.stat.real_goods_list.length
              ? _c(
                  "div",
                  { staticClass: "real-prize-box" },
                  [
                    _vm._l(_vm.stat.real_goods_list, function (item, index) {
                      return [
                        _c("span", { key: index }, [
                          _vm._v(
                            " " +
                              _vm._s(item.prize_name) +
                              "*" +
                              _vm._s(item.prize_value)
                          ),
                          index != _vm.stat.real_goods_list.length - 1
                            ? _c("i", [_vm._v("，")])
                            : _vm._e(),
                        ]),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "panel detail-panel" },
        [
          _c("p", { staticClass: "title" }, [_vm._v("中奖明细")]),
          _c("div", { staticClass: "tip" }, [
            _vm._v(
              "注：如果单笔订单失效，关联到的开奖次数也会失效，开奖中的奖品会做失效处理"
            ),
          ]),
          _c(
            "van-list",
            {
              attrs: {
                finished: _vm.finished,
                "finished-text": _vm.list.length ? "亲，到底了哦～" : "",
                error: _vm.error,
                "error-text": "请求失败，点击重新加载",
              },
              on: {
                "update:error": function ($event) {
                  _vm.error = $event
                },
                load: _vm.getAwardList,
              },
              model: {
                value: _vm.loading,
                callback: function ($$v) {
                  _vm.loading = $$v
                },
                expression: "loading",
              },
            },
            [
              _vm._l(_vm.list, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "detail-item van-hairline--bottom",
                  },
                  [
                    _c("div", { staticClass: "detail-item-left" }, [
                      _c("p", { staticClass: "prize-name" }, [
                        _vm._v(_vm._s(item.prize_name)),
                      ]),
                      _c("p", { staticClass: "draw-time" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatDate")(
                              item.draw_time,
                              "YYYY-mm-dd HH:MM:SS"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "status",
                        class: { valid: item.draw_status === 1 },
                      },
                      [_vm._v(_vm._s(item.draw_status === 1 ? "有效" : "失效"))]
                    ),
                    item.invalid_reason
                      ? _c("div", { staticClass: "invalid-reason" }, [
                          _vm._v(_vm._s(item.invalid_reason)),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              !_vm.list.length
                ? _c("div", { staticClass: "no-data-tip" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/views/activity2022/assets/img/202212/nhj/jd_nodate@2x.png"),
                        alt: "",
                      },
                    }),
                    _c("p", [_vm._v("暂无活动数据~")]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          staticClass: "address-pop",
          model: {
            value: _vm.addressPop,
            callback: function ($$v) {
              _vm.addressPop = $$v
            },
            expression: "addressPop",
          },
        },
        [
          _c("div", { staticClass: "address-pop-con" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "label" }, [_vm._v("收件人")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.addressInfo.consignee,
                    expression: "addressInfo.consignee",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: "请输入收货人姓名",
                  maxlength: "20",
                },
                domProps: { value: _vm.addressInfo.consignee },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.addressInfo,
                      "consignee",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "label" }, [_vm._v("手机号")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.addressInfo.phone,
                    expression: "addressInfo.phone",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: "请输入联系方式",
                  maxlength: "11",
                },
                domProps: { value: _vm.addressInfo.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.addressInfo,
                      "phone",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "label" }, [_vm._v("收货地址")]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.addressInfo.address,
                    expression: "addressInfo.address",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "textarea",
                attrs: {
                  placeholder: "省、市、区、街道、小区楼栋/乡镇名称等",
                  maxlength: "100",
                },
                domProps: { value: _vm.addressInfo.address },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.addressInfo,
                      "address",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "tip" }, [
              _vm._v("注：请填写正确的信息内容，以免获奖收不到奖品"),
            ]),
            _c(
              "div",
              {
                staticClass: "submit-btn",
                class: { "can-submit": _vm.addressInfoValid },
                on: { click: _vm.submitAddressInfo },
              },
              [_vm._v("确认保存")]
            ),
          ]),
          _c("div", {
            staticClass: "close-btn",
            on: {
              click: function ($event) {
                _vm.addressPop = false
              },
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }